import { useEffect, useState } from 'react';
import { Room, Participant } from 'twilio-video';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useParticipantCount() {
  const { room } = useVideoContext();
  const [participantCount, setParticipantCount] = useState(0);
  const [isCallEstablished, setIsCallEstablished] = useState(false);

  useEffect(() => {
    if (!room) {
      setParticipantCount(0);
      setIsCallEstablished(false);
      return;
    }

    const updateParticipantCount = () => {
      // ローカル参加者を含む総参加者数
      const totalParticipants = room.participants.size + 1; // +1 for local participant
      setParticipantCount(totalParticipants);

      // 2人以上参加したら通話確立とみなす
      setIsCallEstablished(totalParticipants >= 2);
    };

    // 初期状態を設定
    updateParticipantCount();

    // 参加者が追加された時
    const handleParticipantConnected = (participant: Participant) => {
      updateParticipantCount();
    };

    // 参加者が切断された時
    const handleParticipantDisconnected = (participant: Participant) => {
      updateParticipantCount();
    };

    // イベントリスナーを追加
    room.on('participantConnected', handleParticipantConnected);
    room.on('participantDisconnected', handleParticipantDisconnected);

    // クリーンアップ
    return () => {
      room.off('participantConnected', handleParticipantConnected);
      room.off('participantDisconnected', handleParticipantDisconnected);
    };
  }, [room]);

  return {
    participantCount,
    isCallEstablished,
  };
}
